import React, { useEffect, useState } from "react";
import { useRouteMatch, useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  getPatientAllergies,
  getPatientAllergiesForPagination,
} from "./../../../store/actions";
import FirstView from "../Repeated-Component/FirstView";
import Pagination from "../../Pagination";
import AllergiesImg from "./../../../assets/Allergies.png";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const AllergiesChild = ({
  getPatientAllergies,
  AllergiesList,
  getPatientAllergiesForPagination,
  history,
}) => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const sharedToken = new URLSearchParams(location.search).get("sharedToken");
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Allergies, setAllergies] = useState([]);
  const [filterAllergies, setFilterAllergies] = useState([]);
  const [currentPage, setCuttentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const pagesNumber = Math.ceil(totalResults / 15);
  let query = useQuery().get("page");

  const nextPage = () => {
    const next = currentPage + 1;
    history.push(`${url}?page=${next}`);
  };

  const prevPage = () => {
    const prev = currentPage - 1;
    history.push(`${url}?page=${prev}`);
  };

  const specificPage = (pageNum) => {
    history.push(`${url}?page=${pageNum}`);
  };

  useEffect(() => {
    if (!query) getPatientAllergies(params.patientId, sharedToken);
  }, [getPatientAllergies, query, params, sharedToken]);

  useEffect(() => {
    if (query)
      getPatientAllergiesForPagination(query, params.patientId, sharedToken);
  }, [getPatientAllergiesForPagination, query, params, sharedToken]);

  useEffect(() => {
    const { loading, error, data } = AllergiesList;
    setLoading(loading);
    setError(error);
    if (data && data.data) {
      const list = data.data;
      setAllergies(list);
      setFilterAllergies(list);
      setTotalResults(data.meta.total);
      setCuttentPage(data.meta.current_page);
    }
  }, [AllergiesList]);

  const renderView = () => {
    return (
      <>
        <FirstView
          headerName="Allergies"
          buttonLink={`${url}/add-allergies`}
          cardLink={`${url}/view-allergies`}
          data={Allergies}
          filterData={filterAllergies}
          setFilter={setFilterAllergies}
          loading={loading}
          error={error}
          imageForEmptyView={AllergiesImg}
          secondTitle="Allergy"
        />
        {totalResults > 15 && filterAllergies.length > 10 ? (
          <Pagination
            pages={pagesNumber}
            nextPage={nextPage}
            prevPage={prevPage}
            specificPage={specificPage}
            currentPage={currentPage}
          />
        ) : (
          ""
        )}
      </>
    );
  };
  return renderView();
};
const mapStateToprops = (state) => {
  return {
    AllergiesList: state.AllergiesList,
  };
};
export default connect(mapStateToprops, {
  getPatientAllergies,
  getPatientAllergiesForPagination,
})(AllergiesChild);
